module.exports = __webpack_public_path__ + "static/media/tuesday-in-german.6c66337c.png";